import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

interface ToggleGroupContextValue {
  orientation: 'horizontal' | 'vertical';
  selectedValue?: string;
}

const ToggleGroupContext = createContext<ToggleGroupContextValue | undefined>(
  undefined,
);

interface ToggleGroupProviderProps {
  orientation: ToggleGroupContextValue['orientation'];
  selectedValue?: ToggleGroupContextValue['selectedValue'];
  children: ReactNode;
}

const ToggleGroupProvider = ({
  orientation,
  selectedValue,
  children,
}: ToggleGroupProviderProps): JSX.Element => {
  const contextValue = { orientation, selectedValue };

  return (
    <ToggleGroupContext.Provider value={contextValue}>
      {children}
    </ToggleGroupContext.Provider>
  );
};

function useToggleGroup(): ToggleGroupContextValue {
  const context = useContext(ToggleGroupContext);

  if (!context) {
    throw new Error('useToggleGroup must be used within ToggleGroupContext');
  }

  return context;
}

export { ToggleGroupProvider, useToggleGroup };
